<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
    <!-- Icon from IconaMoon by Dariush Habibpour - https://creativecommons.org/licenses/by/4.0/ -->
    <g fill="none">
      <path
        fill="currentColor"
        d="M4 8h16v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"
        opacity=".2"
      ></path>
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M4 4h16v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm0 4h16m-4-5v2M8 3v2"
      ></path>
    </g>
  </svg>
</template>

<script lang="ts">
export default {
  name: "IconamoonCalendar1Duotone",
};
</script>
